import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { Subscriptions } from "./types.js";
addProp(_List, "subscriptions", Subscriptions);
//# sourceMappingURL=list.js.map